import { Link } from "react-router-dom";

const STORY_IMG =
  "https://images.unsplash.com/photo-1774169440296-9b366349b048?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxhcG90aGVjYXJ5JTIwbGFiJTIwc3RpbGwlMjBsaWZlfGVufDB8fHx8MTc4MTQyODU1MXww&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <div data-testid="about-page" className="animate-in fade-in duration-500">
      <section className="px-6 md:px-12 lg:px-24 pt-24 pb-12 max-w-4xl">
        <p className="overline text-primary mb-5">About RegenX Wellness</p>
        <h1 className="editorial-heading text-5xl md:text-7xl text-secondary leading-[0.95] mb-8">
          Research, raised <em className="italic text-primary">to the level of craft.</em>
        </h1>
        <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
          We supply investigational peptides to academic, clinical, and independent
          researchers worldwide. Every batch is third-party assayed; every shipment
          chain-of-custody tracked. We sell strictly for research and laboratory use.
        </p>
      </section>

      <section className="px-6 md:px-12 lg:px-24 py-16">
        <img src={STORY_IMG} alt="" className="w-full max-h-[60vh] object-cover" />
      </section>

      <section className="px-6 md:px-12 lg:px-24 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <p className="overline text-primary mb-4">Quality dossier</p>
          <h2 className="editorial-heading text-4xl text-secondary">Our standard.</h2>
        </div>
        <div className="md:col-span-7 md:col-start-6 space-y-6 text-muted-foreground">
          <p><strong className="text-secondary">HPLC ≥ 99% purity</strong> — every lot tested by reverse-phase HPLC against reference standards.</p>
          <p><strong className="text-secondary">Mass spectrometry</strong> — molecular mass verified to ±0.1 Da.</p>
          <p><strong className="text-secondary">Sterility & endotoxin</strong> — USP &lt;71&gt; and &lt;85&gt; protocols.</p>
          <p><strong className="text-secondary">Chain of custody</strong> — independent lab to vial.</p>
          <p><strong className="text-secondary">Shipped from Melbourne</strong> — dispatched directly from our Melbourne facility to researchers worldwide.</p>
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-24 py-16 grid grid-cols-1 md:grid-cols-12 gap-12 bg-muted">
        <div className="md:col-span-4">
          <p className="overline text-primary mb-4">Compliance</p>
          <h2 className="editorial-heading text-4xl text-secondary">Research Use Only.</h2>
        </div>
        <div className="md:col-span-7 md:col-start-6 space-y-6 text-muted-foreground">
          <p>
            All products sold by RegenX Wellness are intended exclusively for in vitro research
            and laboratory experimentation. They are not approved as drugs, food, cosmetics, or
            household chemicals; they are not for human or veterinary administration,
            consumption, diagnostic use, or therapeutic application.
          </p>
          <p>
            By placing an order you confirm that you are 18+ and a qualified researcher, and
            that you accept full responsibility for handling, storage, and disposal under
            applicable laws.
          </p>
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-24 py-16 text-center">
        <h2 className="editorial-heading text-4xl md:text-5xl text-secondary mb-6">
          Talk to us.
        </h2>
        <p className="text-muted-foreground mb-8">
          Bulk inquiries, COA reissues, or research collaboration —{" "}
          <a
            href="mailto:info@regenxwellness.com.au"
            className="text-secondary underline underline-offset-4 hover:text-primary"
            data-testid="about-contact-email"
          >
            info@regenxwellness.com.au
          </a>
        </p>
        <Link
          to="/"
          className="inline-flex items-center justify-center border border-secondary text-secondary px-8 py-4 uppercase tracking-[0.22em] text-xs hover:bg-secondary hover:text-secondary-foreground transition-colors"
        >
          Back home
        </Link>
      </section>
    </div>
  );
}
